/* Bundle builder — home-redesign (.home-rd) section
 * Vanilla, scoped, no dependencies. Mirrors the design mock's initBundle():
 *   - tap a .bpick to add/remove (MAX 3)
 *   - three .bslot slots, a progress bar (#bundle-bar = picks/3), a running total
 *   - total shows the bundle price when exactly 3 are selected, else the sum of picks
 *   - "Add bundle to cart" (#bundle-add) adds the 3 selected variants via Shopify cart AJAX
 *
 * The 3-for-$45 discount is AUTOMATIC at checkout — this never applies a discount code.
 *
 * Markup hooks (reference look): #bundle (root section), #bundle-slots (3 .bslot),
 * #bundle-bar, #bundle-msg, #bundle-total, #bundle-add, #bundle-picks (.bpick tiles),
 * #bundle-toast / #bundle-toast-text.
 */
(function () {
  'use strict';

  var MAX = 3;

  // Format cents using the shop's money format if Shopify exposes it, else a plain $.
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
      try {
        return window.Shopify.formatMoney(cents, fmt);
      } catch (e) {
        /* fall through */
      }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function BundleBuilderInit(root) {
    var picksWrap = root.querySelector('#bundle-picks');
    var slotsEl = root.querySelector('#bundle-slots');
    var barEl = root.querySelector('#bundle-bar');
    var progressEl = root.querySelector('.bundle-progress');
    var msgEl = root.querySelector('#bundle-msg');
    var totalEl = root.querySelector('#bundle-total');
    var addBtn = root.querySelector('#bundle-add');
    var toastEl = root.querySelector('#bundle-toast');
    var toastTextEl = root.querySelector('#bundle-toast-text');

    if (!picksWrap || !slotsEl || !addBtn) return;

    var bundlePrice = parseInt(root.getAttribute('data-bundle-price'), 10) || 0;
    var bundleSize = parseInt(root.getAttribute('data-bundle-size'), 10) || MAX;

    var promptEmpty =
      (msgEl && (msgEl.getAttribute('data-prompt-empty') || msgEl.textContent.trim())) ||
      'Pick 3 to unlock the bundle price.';
    var addLabel = addBtn.textContent.trim() || 'Add bundle to cart';

    // Selected picks (in order chosen). Each item: { variantId, productId, price, title, img, el }
    var selected = [];
    var toastTimer = null;

    var pickButtons = Array.prototype.slice.call(picksWrap.querySelectorAll('.bpick'));

    function pickId(btn) {
      return btn.getAttribute('data-variant-id') || btn.getAttribute('data-id');
    }

    function findIndex(variantId) {
      for (var i = 0; i < selected.length; i += 1) {
        if (selected[i].variantId === variantId) return i;
      }
      return -1;
    }

    function showToast(text) {
      if (!toastEl) return;
      if (toastTextEl) toastTextEl.textContent = text;
      toastEl.hidden = false;
      // force reflow so the transition runs from the hidden state
      void toastEl.offsetWidth;
      toastEl.classList.add('is-show');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('is-show');
        toastTimer = setTimeout(function () {
          toastEl.hidden = true;
        }, 300);
      }, 3000);
    }

    function renderSlots() {
      var slotItems = Array.prototype.slice.call(slotsEl.querySelectorAll('.bslot'));
      slotItems.forEach(function (slot, i) {
        var pick = selected[i];
        if (pick) {
          slot.classList.add('filled');
          slot.innerHTML = '';
          if (pick.img) {
            var img = document.createElement('img');
            img.src = pick.img;
            img.alt = '';
            slot.appendChild(img);
          }
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'bslot-x';
          rm.setAttribute('data-rm', pick.variantId);
          rm.setAttribute('aria-label', 'Remove ' + pick.title + ' from bundle');
          rm.innerHTML = '&times;';
          slot.appendChild(rm);
        } else {
          slot.classList.remove('filled');
          slot.innerHTML = '<span aria-hidden="true">' + (i + 1) + '</span>';
        }
      });
    }

    function render() {
      renderSlots();

      // Progress
      var pct = (selected.length / bundleSize) * 100;
      if (barEl) barEl.style.width = pct + '%';
      if (progressEl) progressEl.setAttribute('aria-valuenow', String(selected.length));

      // Message
      var remain = bundleSize - selected.length;
      if (msgEl) {
        if (selected.length === 0) {
          msgEl.textContent = promptEmpty;
        } else if (remain > 0) {
          msgEl.innerHTML =
            selected.length + ' of ' + bundleSize + ' selected — add <b>' + remain + ' more</b>.';
        } else {
          msgEl.innerHTML = 'Bundle complete! <b>' + bundleSize + ' for ' + formatMoney(bundlePrice) + '</b>';
        }
      }

      // Total: bundle price at exactly N, else the running sum of selected prices
      var full = selected.reduce(function (a, p) { return a + p.price; }, 0);
      if (totalEl) {
        totalEl.textContent = selected.length === bundleSize ? formatMoney(bundlePrice) : formatMoney(full);
      }

      // CTA enabled only at exactly N
      addBtn.disabled = selected.length !== bundleSize;
      addBtn.classList.toggle('is-ready', selected.length === bundleSize);

      // Reflect picked state on the picker buttons
      pickButtons.forEach(function (b) {
        var on = findIndex(pickId(b)) >= 0;
        b.classList.toggle('picked', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function togglePick(btn) {
      if (btn.disabled) return;
      var variantId = pickId(btn);
      if (!variantId) return;
      var idx = findIndex(variantId);
      if (idx >= 0) {
        selected.splice(idx, 1);
      } else {
        if (selected.length >= bundleSize) {
          showToast('Bundle is full — remove one first.');
          return;
        }
        var imgEl = btn.querySelector('img');
        selected.push({
          variantId: variantId,
          productId: btn.getAttribute('data-product-id'),
          price: parseInt(btn.getAttribute('data-price'), 10) || 0,
          title: btn.getAttribute('data-title') || '',
          img: imgEl ? (imgEl.currentSrc || imgEl.src) : '',
          el: btn
        });
      }
      render();
    }

    // ---- Picker interactions (delegated) ----
    picksWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.bpick');
      if (btn) togglePick(btn);
    });

    // ---- Slot remove (delegated) ----
    slotsEl.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-rm]');
      if (!rm) return;
      var idx = findIndex(rm.getAttribute('data-rm'));
      if (idx >= 0) {
        selected.splice(idx, 1);
        render();
      }
    });

    // ---- Notify the theme so the cart bubble updates (Horizon "cart:update") ----
    function notifyCartUpdate(itemCount) {
      // Match the theme's CartUpdateEvent shape (cart-icon.js reads detail.data.itemCount).
      // detail MUST go through the constructor: CustomEvent.detail is getter-only,
      // and assigning it afterwards throws in strict mode.
      var detail = {
        resource: null,
        sourceId: 'bundle-builder',
        data: { source: 'bundle-builder', itemCount: itemCount }
      };
      var evt;
      try {
        evt = new CustomEvent('cart:update', { bubbles: true, detail: detail });
      } catch (e) {
        evt = document.createEvent('CustomEvent');
        evt.initCustomEvent('cart:update', true, false, detail);
      }
      root.dispatchEvent(evt);
    }

    // ---- Add the N selected variants to the cart ----
    addBtn.addEventListener('click', function () {
      if (selected.length !== bundleSize || addBtn.disabled) return;

      addBtn.disabled = true;
      addBtn.classList.add('is-busy');
      addBtn.textContent = 'Adding…';

      var items = selected.map(function (p) {
        return { id: parseInt(p.variantId, 10), quantity: 1 };
      });

      // No discount code — the 3-for-$45 price is automatic at checkout.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            // Surface Shopify's own message (e.g. "The maximum quantity of this
            // item is already in your cart.") instead of a generic failure.
            return res.json().then(
              function (err) {
                var msg = (err && (err.description || err.message)) || '';
                var e = new Error(msg || 'Cart add failed: ' + res.status);
                e.friendly = !!msg;
                throw e;
              },
              function () {
                throw new Error('Cart add failed: ' + res.status);
              }
            );
          }
          return res.json();
        })
        .then(function () {
          // Read the authoritative cart count, then update the header bubble.
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              if (cart && typeof cart.item_count === 'number') {
                notifyCartUpdate(cart.item_count);
              }
            });
        })
        .then(function () {
          showToast('3-for-' + formatMoney(bundlePrice) + ' bundle added!');
        })
        .catch(function (e) {
          showToast(e && e.friendly && e.message ? e.message : 'Something went wrong — please try again.');
        })
        .finally(function () {
          addBtn.classList.remove('is-busy');
          addBtn.textContent = addLabel;
          // Re-enable only if a full bundle is still selected.
          addBtn.disabled = selected.length !== bundleSize;
        });
    });

    render();
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll('#bundle[data-bundle-size]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.dataset.bbInit) return;
      el.dataset.bbInit = '1';
      BundleBuilderInit(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
